import { useAppContext } from 'app/useAppContext'
import { useUpdateStack } from 'data/hooks/stacks'

import { useToast } from 'ui/components/Toast'

export function useAiAppSettingsControlsState() {
    const { selectedStack } = useAppContext()

    const toast = useToast()
    const { mutateAsync: updateStack } = useUpdateStack()
    const updateStackOptions = async (patch: Partial<StackDto['options']>) => {
        if (!selectedStack) return

        try {
            await updateStack({
                id: selectedStack._sid,
                patch: {
                    options: {
                        ...selectedStack.options,
                        ...patch,
                    },
                },
            })

            toast({
                type: 'success',
                title: 'App updated successfully',
                startIcon: {
                    name: 'CheckCircle',
                },
                showDismissButton: true,
            })
        } catch {
            toast({
                type: 'error',
                startIcon: {
                    name: 'AlertCircle',
                },
                title: 'There was a problem updating the app',
                helperText: 'Please try again later. If the issue persists, contact support.',
            })
        }
    }

    const currentDefaultModel = selectedStack?.options?.ai_default_model
    const onChangeDefaultModel = (model?: string) => {
        updateStackOptions({ ai_default_model: model })
    }

    return {
        currentDefaultModel,
        onChangeDefaultModel,
    }
}
